import { differenceInCalendarDays, parseISO } from "date-fns"
import type { EventDTO } from "@/js/types/generated"

const DEFAULT_MIN_HOUR = 8
const DEFAULT_MAX_HOUR = 18

const toSlotTime = (hour: number): string => `${String(hour).padStart(2, "0")}:00:00`

/**
 * The hour range a time grid needs to show every timed event, widened to at least the default business hours.
 */
export const getSlotTimeRange = (events: EventDTO[]): { slotMinTime: string; slotMaxTime: string } => {
	let minHour = DEFAULT_MIN_HOUR
	let maxHour = DEFAULT_MAX_HOUR

	for (const event of events.filter((e) => !e.allDay)) {
		const start = parseISO(event.start)
		const end = event.end ? parseISO(event.end) : start
		if (differenceInCalendarDays(end, start) > 0) return { slotMinTime: toSlotTime(0), slotMaxTime: toSlotTime(24) }

		minHour = Math.min(minHour, start.getHours())
		maxHour = Math.max(maxHour, end.getHours() + (end.getMinutes() > 0 ? 1 : 0), start.getHours() + 1)
	}

	return { slotMinTime: toSlotTime(minHour), slotMaxTime: toSlotTime(maxHour) }
}
